import React, { useState } from 'react';
import { useAsyncDebounce } from '@/common/react-table-utils';
import { Maybe } from '@/common/types';
import { SearchFilter, ClearFilter } from '@/components/Patients/styles';
import { NameTextFieldContainer, NameTextField } from '@/components/common/Table/PatientsTable/styles';
import { usePaginationContext } from '@/components/context/hooks/PaginationContext';

interface TableSearchFilterProps {
    filter: Maybe<string>;
    setFilter: React.Dispatch<React.SetStateAction<unknown>>;
    searchLabel: string;
    disabled?: boolean;
}

export const TableSearchFilter = (props: TableSearchFilterProps) => {
    const { filter, setFilter, searchLabel, disabled } = props;
    const [value, setValue] = useState(filter);
    const { page, setPage } = usePaginationContext();
    const onChange = useAsyncDebounce((value) => {
        setFilter(value || undefined);
    }, 200);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (page !== 1) {
            setPage(1);
        }
        setValue(e.target.value);
        onChange(e.target.value);
    };

    const handleClear = (_: React.MouseEvent) => {
        if (page !== 1) {
            setPage(1);
        }
        setValue(undefined);
        setFilter(undefined);
    };

    return (
        <NameTextFieldContainer>
            <NameTextField
                value={value || ''}
                onChange={handleChange}
                id="name-filter"
                label={searchLabel}
                variant="outlined"
                size="small"
                disabled={disabled}
            />
            {!value ? (
                <SearchFilter color={!value ? 'disabled' : 'inherit'} onClick={handleClear} />
            ) : (
                <ClearFilter color={!value ? 'disabled' : 'inherit'} onClick={handleClear} />
            )}
        </NameTextFieldContainer>
    );
};
